"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMiddleware = void 0;
exports.createMiddleware = (registry) => {
    return (store) => (next) => (action) => {
        const result = next(action);
        registry.process(store.getState, action);
        return result;
    };
};
